import { render, staticRenderFns } from "./TravellerList.vue?vue&type=template&id=5b09250a&scoped=true&"
import script from "./TravellerList.vue?vue&type=script&lang=js&"
export * from "./TravellerList.vue?vue&type=script&lang=js&"
import style0 from "./TravellerList.vue?vue&type=style&index=0&id=5b09250a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09250a",
  null
  
)

export default component.exports